/**
 * 'Index'
 * @version 1.0.0
 * @author Fernando Torres
 * @copyright Marciano Studio S.C., 2018
 */
import appRoutes from './app.routes'
import loginRoutes from './login.routes'

export default [
  ...loginRoutes,
  ...appRoutes
]



// WEBPACK FOOTER //
// ./src/router/routes/index.js